import React, { useMemo } from 'react';
import { Form, Select, Input, InputNumber, Checkbox, Space, Row, Col } from 'antd';
import standardDimensions from 'shared/constants/dimensions';
import { dimensionSupportsIgnoreCasing } from 'shared/utils/ignoreDimensionCasing';
import useFormatMessage from 'hooks/useFormatMessage';
import { getDimensionLabel } from 'components/DimensionLabel';

const DimensionConfig = () => {
  const $t = useFormatMessage();
  const dimension = Form.useWatch('dimension');
  const dimensionOptions = useMemo(() => {
    const options = Object.entries(standardDimensions).map(([d]) => ({
      label: getDimensionLabel({ $t, dimension: d }),
      value: d,
    }));
    return options;
  }, [$t]);

  return (
    <>
      <Form.Item label="Dimension" name="dimension">
        <Select options={dimensionOptions} showSearch optionFilterProp="label" />
      </Form.Item>
      <Form.Item label="Label" name="label">
        <Input.TextArea rows={2} />
      </Form.Item>
      <Row gutter={16}>
        <Col>
          <Form.Item label="Sort priority" name="sortPriority">
            <InputNumber />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label="Sort order" name="sortOrder">
            <Select options={[
              { label: 'Ascending', value: 'asc' },
              { label: 'Descending', value: 'desc' },
            ]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="Column width" name="width">
        <InputNumber min={50} max={400} />
      </Form.Item>
      <Space direction="vertical">
        {dimensionSupportsIgnoreCasing(standardDimensions[dimension]) && (
          <Form.Item name="ignoreCasing" valuePropName="checked" noStyle>
            <Checkbox>Ignore casing</Checkbox>
          </Form.Item>
        )}
        <Form.Item name="truncate" valuePropName="checked" noStyle>
          <Checkbox>Truncate</Checkbox>
        </Form.Item>
        <Form.Item name="hidden" valuePropName="checked" noStyle>
          <Checkbox>Hidden</Checkbox>
        </Form.Item>
      </Space>
    </>
  );
};

export default DimensionConfig;
